import SearchInput from "../../components/inputs/searchInput";
import { useFormik } from "formik";
import SearchSelect from "../../components/select/searchSelect";
import DateSearchInput from "../../components/inputs/dateSearchInput";
import { useOptions } from "../../components/hooks/useOptionsHook";

const SearchActivity = ({ t }) => {
  const formik = useFormik({ initialValues: {} });
  const { employeesStatusOptions } = useOptions();

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 md:flex-nowrap">
      <div className="flex flex-wrap items-center w-full gap-3 md:w-1/2 md:flex-nowrap">
        <div className="flex-1">
          <SearchInput
            formik={formik}
            name={"search"}
            placeholder={t("searchWithName")}
          />
        </div>
        <div className="w-full md:w-auto">
          <SearchSelect
            options={employeesStatusOptions}
            formik={formik}
            name={"status"}
            placeholder={t("eventCategory")}
          />
        </div>
        <div className="w-full md:w-auto">
          <DateSearchInput
            formik={formik}
            name={"status"}
            placeholder={t("startDate")}
          />
        </div>
        <div className="w-full md:w-auto">
          <SearchSelect
            options={employeesStatusOptions}
            formik={formik}
            name={"status"}
            placeholder={t("status")}
          />
        </div>
      </div>
      <div className="w-full md:w-auto">
        <SearchSelect
          options={employeesStatusOptions}
          formik={formik}
          name={"download"}
          placeholder={t("downloadFile")}
        />
      </div>
    </section>
  );
};

export default SearchActivity;
